const HP_TO_NEXT_LEVEL_START = 25;
const HP_TO_NEXT_LEVEL_GROWTH = 25;

export type LevelInfo = {
    level: number;
    progress: number;
    hpNeeded: number;
    fromHp: number;
    toHp: number;
};

export function getLevelInfo(hp: number): LevelInfo {
    if (hp < 0) {
        return {
            level: 0,
            progress: 0,
            hpNeeded: HP_TO_NEXT_LEVEL_START,
            fromHp: 0,
            toHp: HP_TO_NEXT_LEVEL_START,
        };
    }
    let level = 1;
    let threshold = 0;
    let step = HP_TO_NEXT_LEVEL_START;
    while (threshold + step <= hp) {
        threshold += step;
        level++;
        step += HP_TO_NEXT_LEVEL_GROWTH;
    }
    return { level, progress: hp - threshold, hpNeeded: step, fromHp: threshold, toHp: threshold + step };
}

export type RankTierBoundary = {
    min: number;
    max: number;
    label: string;
};

export const RANK_TIER_BOUNDARIES: readonly RankTierBoundary[] = [
    { min: 1, max: 5, label: 'Bronze' },
    { min: 6, max: 10, label: 'Silver' },
    { min: 11, max: 15, label: 'Gold' },
    { min: 16, max: 20, label: 'Platinum' },
    { min: 21, max: 25, label: 'Sapphire' },
    { min: 26, max: 30, label: 'Emerald' },
    { min: 31, max: 35, label: 'Ruby' },
    { min: 36, max: 40, label: 'Diamond' },
    { min: 41, max: 50, label: 'Master' },
    { min: 51, max: 60, label: 'Legend' },
    { min: 61, max: Infinity, label: 'Mythic' },
] as const;

export function getRankTierIndex(level: number): number {
    const idx = RANK_TIER_BOUNDARIES.findIndex(tier => level >= tier.min && level <= tier.max);
    return idx === -1 ? RANK_TIER_BOUNDARIES.length - 1 : idx;
}

export function maxShieldTokensForHp(totalHp: number): number {
    const { level } = getLevelInfo(totalHp);
    return getRankTierIndex(level) + 1;
}
